import React from 'react';
import { Button, Popover } from '../../../../../../../components/UI';
import { useAppDispatch } from '../../../../../../../store/hooks';
import { openDocument } from '../../../../../../../store/document/slice';
import styles from './SourceItem.module.scss';
import { ClientChatSource } from '../../../../../../../store/chat/types';
import HTMLTable from '../../../../../../../components/HTMLTable';
import { trackEvent } from '../../../../../../../services/tracking';

interface SourceItemProps {
  source: ClientChatSource;
  index: number;
}

const getFileNameWithoutExtension = (fileName: string) => {
  const lastDot = fileName.lastIndexOf('.');
  return lastDot === -1 ? fileName : fileName.substring(0, lastDot);
};

const renderContent = (source: ClientChatSource) => {
  if (source.chunk_type === 'image' && /^https?:\/\//.test(source.content)) {
    return (
      <img
        src={source.content}
        alt={source.file_name}
        style={{ maxWidth: '100%', maxHeight: 300, borderRadius: 8 }}
      />
    );
  }

  if (source.chunk_type === 'table') {
    return <HTMLTable html={source.content} />;
  }

  return <div className={styles.contextSourceContent}>{source.content}</div>;
};

const SourceItem: React.FC<SourceItemProps> = ({ source, index }) => {
  const dispatch = useAppDispatch();

  const handleOpenDocument = () => {
    if (!source.document_id) return;

    trackEvent('Citation Opened', {
      location: 'ChatMessage',
      documentId: source.document_id,
      pageId: source.page_id,
      fileName: source.file_name,
    });

    dispatch(
      openDocument({
        documentId: source.document_id,
        pageId: source.page_id,
        textToHighlight: source.content,
      }),
    );
  };

  return (
    <Popover
      trigger={<span className={styles.popoverTriggerButton}>{index + 1}</span>}
      className={styles.contextSource}
    >
      {(closePopover) => (
        <div className={styles.popoverContent}>
          <div className={styles.popoverFileName}>
            {getFileNameWithoutExtension(source.file_name)}
          </div>
          {renderContent(source)}
          <div className={styles.popoverFooter}>
            <Button
              variant="ghost"
              size="small"
              onClick={() => {
                handleOpenDocument();
                closePopover();
              }}
            >
              View Document
            </Button>
          </div>
        </div>
      )}
    </Popover>
  );
};

export default SourceItem;
